export default "__VITE_ASSET__BkWyBXXO__"